import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "api";
import axios, { AxiosError } from "axios";
import { T_Api_Success_Res } from "./api.types";

export const fileService = {
  uploadMiltipleFiles: () => {
    return;
  },
  useFetchFileUrl: () => {
    return useMutation({
      mutationKey: ["fileUrl"],
      mutationFn: async ({ fileId, appKey }: { fileId: string; appKey: string }) => {
        const res = await api.get(`/lead/external/file/${fileId}?app_key=${appKey}`);
        return res.data as T_Api_Success_Res<{ link: string; base: string; dir: string; key: string }>;
      },
    });
  },
  useGetExternalUrl: (fileUrl: string | undefined | null) => {
    return useQuery({
      queryKey: ["file", fileUrl],
      queryFn: async () => {
        if (!fileUrl) throw new AxiosError("Link not valid or file not found", "404");
        const res = await axios.get(fileUrl);
        return res.data;
      },
      enabled: !!fileUrl,
    });
  },
};
